import { useTranslation } from "react-i18next"

import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import Pagination from "@/components/Pagination/Pagination"
import FeedbacksShow from "@/features/pages/Feedbacks/FeedbacksShow"
import { useAllFeedbacksData } from "@/queries/queries"

export default function Feedbacks() {
  const feedbackQuery = useAllFeedbacksData()

  const { t } = useTranslation()

  let content
  if (feedbackQuery.isLoading) {
    content = <Loading />
  } else if (!feedbackQuery.data?.data.length) {
    content = <NoMessage name={t("noMessages.feedbacks")} />
  } else {
    content = (
      <>
        <FeedbacksShow feedbacks={feedbackQuery.data.data} />
        <Pagination pagination={feedbackQuery.data.meta} route="feedbacks" />
      </>
    )
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bolder mb-0">{t("feedbacksPage.title")}</h5>
      </div>
      {content}
    </div>
  )
}
